import React from "react";
import { Network } from "lucide-react";
import GlobalDetailDrawer from "modules/swiftboard/components/GlobalDetailDrawer";
import { SOURCE_STATUS, TRIGGER_TYPE_LABEL } from "../../../features/builder.constants";

const empty = (text) => [{ value: <p className="text-xs text-text_muted">{text}</p> }];

// Triggers and domain events built on a source (a source they use can't be deleted, nor archived while an
// active trigger uses it).
export default function UsedByDrawer({ source, usedBy, onClose }) {
  const triggers = usedBy?.triggers ?? [];
  const events = usedBy?.domain_events ?? [];

  const sections = [
    {
      title: `Triggers (${triggers.length})`,
      fields: triggers.length
        ? triggers.map((trigger) => ({
            label: trigger.code,
            value: `${trigger.name || "—"} · ${TRIGGER_TYPE_LABEL[trigger.trigger_type] ?? trigger.trigger_type} · ${SOURCE_STATUS[trigger.status]?.label ?? trigger.status}`,
          }))
        : empty("No trigger uses this source yet."),
    },
    {
      title: `Domain events (${events.length})`,
      fields: events.length ? events.map((event) => ({ label: event.event_key, value: event.name || "—" })) : empty("No domain event points at this source."),
    },
  ];

  return (
    <GlobalDetailDrawer
      open
      onClose={onClose}
      title="Used by"
      subtitle={`${source.label} · a source in use can't be deleted, and can't be archived while an active trigger uses it`}
      icon={<Network size={20} />}
      sections={sections}
    />
  );
}
